import { FC } from "react";

export const ConditionalWrapper: FC<{
  condition: boolean | void;
  wrapper: (children: React.ReactElement) => React.JSX.Element;
  children: React.JSX.Element;
}> = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);
